import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  GET_BY_ID_REQUEST,
  GET_BY_ID_SUCCESS,
  SEARCH,
  GET_FILTER_PRODUCT_REQUEST,
  GET_FILTER_PRODUCT_SUCCESS,
  SET_LOADING_SELECTS,
  SAVE_REQUEST,
  SET_LOADING_SEND,
  DELETE_ITEMS,
  SET_LOADING_MODAL,
  GET_FILTER_SELECTS_REQUEST,
  GET_FILTER_SELECTS_SUCCESS
} from './product-technical-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const setLoadingSelects = (loading: Boolean) => {
  return {
    type: SET_LOADING_SELECTS,
    loading
  };
};

export const setLoadingModal = (loading: Boolean) => {
  return {
    type: SET_LOADING_MODAL,
    loading
  };
};

export const getAllSelectsRequest = (payload?: any) => {
  return {
    type: GET_FILTER_SELECTS_REQUEST,
    payload
  };
};

export const getAllSelectsSuccess = (payload: any) => {
  return {
    type: GET_FILTER_SELECTS_SUCCESS,
    payload
  };
};

export const getFilterProductRequest = ({ queryText, skip }: { queryText?: string; skip?: number }) => {
  return {
    type: GET_FILTER_PRODUCT_REQUEST,
    queryText,
    skip
  };
};

export const getFilterProductSuccess = payload => {
  return {
    type: GET_FILTER_PRODUCT_SUCCESS,
    payload
  };
};

export const getAllRequest = (payload?: any) => {
  return {
    type: GET_ALL_REQUEST,
    payload
  };
};

export const getAllSuccess = (payload: any) => {
  return {
    type: GET_ALL_SUCCESS,
    payload
  };
};

export const getByIdRequest = (id?: string) => {
  return {
    type: GET_BY_ID_REQUEST,
    id
  };
};

export const getByIdSuccess = (payload: any) => {
  return {
    type: GET_BY_ID_SUCCESS,
    payload
  };
};

export const deleteItems = (payload: any) => {
  return {
    type: DELETE_ITEMS,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const search = (queryString: string) => {
  return {
    type: SEARCH,
    queryString
  };
};

export const saveRequest = (payload, isBatch = false, id?: string) => {
  return {
    type: SAVE_REQUEST,
    payload,
    isBatch,
    id
  };
};
